<template>
  <el-dialog class="select-sku-modal" title="选择份量/口味" :visible.sync="visible" width="400px">
    <div class="content" v-loading="loading">
      <div class="header"></div>
      <div class="table">
        <div class="table-wrapper">
          <el-table
            :data="list"
            stripe
            style="width: 100%"
            height="100%">
            <el-table-column
              prop="index"
              label="#"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="name"
              label="规格"
              align="center">
            </el-table-column>
            <el-table-column
              prop="price"
              label="价格">
            </el-table-column>
            <el-table-column
              prop="operation"
              label="操作"
              fixed="right"
              width="80">
              <template slot-scope="scope">
                <el-button type="text" @click="select(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import _ from 'lodash'
  import ModalMixin from '@/libs/modal/modal-mixin'

  export default {
    mixins: [ModalMixin],
    data () {
      return {
        list: [],
        loading: false
      }
    },
    methods: {
      init (serviceItemId) {
        this.loadData(serviceItemId)
        return this.open()
      },
      loadData (serviceItemId) {
        this.loading = true
        this.Service.call('serviceitemsku', 'GET', {serviceitemgid: serviceItemId}).then(data => {
          _.forEach(data, (item, idx) => {
            item.index = idx + 1
          })
          this.list = data || []
          if (this.list.length === 1) {
            this.close({sku:this.list[0],length:1})
          }
        }).finally(() => {
          this.loading = false
        })
      },
      select (row) {
        this.close({sku:row,length:this.list.length});
      }
    }
  }
</script>
